// src/services/usuarioService.js
import api from "./Api"; // respeta la A mayúscula

// ===================== USUARIOS (permanentes) =====================

// 2FA paso 1: enviar código (antes del login definitivo)
export const enviarTokenLogin = ({ email, password }) =>
  api.post("/Usuarios/enviar-token", { email, password });

// Login (permanente => envía 2FA; temporal => devuelve token directo)
export const login = ({ email, password }) =>
  api.post("/Usuarios/login", { email, password });

// 2FA paso 2: verificar código
export const verificar2FA = ({ email, codigo2FA }) =>
  api.post("/Usuarios/verificar-2fa", { email, codigo2FA });

// Verificar disponibilidad de correo (público) — envía PIN
export const verificarCorreo = (email) =>
  api.post("/Usuarios/verificar-correo", email);

// Actualizar contraseña (permanentes)
export const actualizarContrasena = ({ email, nuevaContrasena }) =>
  api.post("/Usuarios/actualizar-contrasena", { email, nuevaContrasena });

// Info rápida por email
export const obtenerInfoTipo = (email) =>
  api.get("/Usuarios/info-tipo", { params: { email } });

// Perfil
export const obtenerPerfil = () => api.cachedGet("/Usuarios/perfil");
export const actualizarPerfil = (payload) => api.put("/Usuarios/perfil", payload);
export const listarUsuarios = () => api.get("/Usuarios/todos");
export const crearUsuario = (payload) => api.post("/Usuarios/crear-usuario", payload);
export const editarUsuario = (id, payload) => api.put(`/Usuarios/editar/${id}`, payload);
export const desactivarUsuario = (id) => api.delete(`/Usuarios/eliminar/${id}`);
export const listarRoles = () => api.cachedGet("/Roles");

// PIN para cambio de correo (perfiles)
export const solicitarPinVerificarCorreo = (emailNuevo, emailActual) =>
  api.post("/Usuarios/solicitar-pin-cambio-correo", {
    emailNuevo,
    email: emailActual,
  });

// ===================== Recuperación de contraseña con PIN (en UsuariosController) =====================
export const solicitarPinCambioPassword = (email) =>
  api.post("/Usuarios/recuperacion/enviar-token", { email });

export const cambiarPasswordConPin = ({ email, pin, nuevaPassword }) =>
  api.post("/Usuarios/recuperacion/cambiar-contrasena", {
    email,
    token: pin,
    nuevaContrasena: nuevaPassword,
  });

// ===================== USUARIOS TEMPORALES (UsuariosController) =====================
export const crearTemporal = (payload) =>
  api.post("/Usuarios/crear-temporal", payload);

export const verificarCorreoTemporal = (email) =>
  api.post("/Usuarios/verificar-correo-temporal", email);

export const validarCorreoTemporal = (email, codigo) =>
  api.post("/Usuarios/validar-correo-temporal", { email, codigo });

// Mis temporales creados (atajo para no-superadmin)
export const obtenerUsuariosCreadosPorAdmin = () =>
  api.cachedGet("/Usuarios/usuarios-temporales-creados");

// ===================== USUARIOS TEMPORALES (PermisosTemporalesController) =====================
export const listarPermisosTemporales = () =>
  api.cachedGet("/PermisosTemporales/listar");

export const actualizarPermisosTemporales = (id, payload) =>
  api.put(`/PermisosTemporales/actualizar/${id}`, payload);

export const eliminarPermisoTemporal = (id) =>
  api.delete(`/PermisosTemporales/eliminar/${id}`);

// 👇 Alias legacy
export const listarUsuariosTemporales = () => listarPermisosTemporales();

// ===================== export default agrupado =====================
const usuarioService = {
  // permanentes
  enviarTokenLogin,
  login,
  verificar2FA,
  verificarCorreo,
  actualizarContrasena,
  obtenerInfoTipo,
  obtenerPerfil,
  actualizarPerfil,
  listarUsuarios,
  crearUsuario,
  editarUsuario,
  desactivarUsuario,
  listarRoles,
  solicitarPinVerificarCorreo,

  // recuperación (UsuariosController)
  solicitarPinCambioPassword,
  cambiarPasswordConPin,

  // temporales (UsuariosController)
  crearTemporal,
  verificarCorreoTemporal,
  validarCorreoTemporal,
  obtenerUsuariosCreadosPorAdmin,

  // permisos temporales (PermisosTemporalesController)
  listarPermisosTemporales,
  actualizarPermisosTemporales,
  eliminarPermisoTemporal,

  // alias
  listarUsuariosTemporales,
};

export default usuarioService;
